import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../constants/componentTypes";
import * as resources from "../../../constants/resources";
import * as settings from "../../../constants/settings";
import * as navigationActions from "../../../actions/navigationActions";
import * as mainTabActions from "../../../actions/mainTabActions";
import * as translationHelper from "../../../helpers/translationHelper";
import * as modelHelper from "../../../helpers/modelHelper";

import imgLoader from "../../../resources/img/loader.svg";
import noImg from "../../../resources/img/no-image.svg";
import imgPdf from "../../../resources/img/svgicons/pdf.svg";
import imgZoomPlus from "../../../resources/img/svgicons/zoom-plus.svg";
import imgZoomOut from "../../../resources/img/svgicons/zoom-out.svg";
import imgDownload from "../../../resources/img/svgicons/download.svg";
import imgClose from "../../../resources/img/svgicons/close.svg";
import imgMaximizable from "../../../resources/img/svgicons/maximizable.svg";
import imgMaximize from "../../../resources/img/svgicons/maximize.svg";

class ProductFilePreviewModal extends Component {
    visitedParams = null;

    constructor(props) {
        super(props);

        if (
            props.params !== undefined &&
            props.params.visited !== undefined &&
            props.params.visited !== null &&
            typeof props.params.visited === "object"
        ) {
            this.visitedParams = modelHelper.copy(props.params.visited);
        }

        this.state = {
            activeFile: null,
            image: null,
            maximized:
                props.params !== undefined && props.params.maximized !== undefined ? props.params.maximized : false,
            online: props.params !== undefined && props.params.online !== undefined ? props.params.online : false,
            pageNumber: 1,
            zoom: 100,
            imageStore: null,
            productFileList: null,
            loading: true
        };
    }

    getFileById = (fileId) => {
        for (let productFile of this.props.productFileList) {
            if (productFile.id === fileId) {
                return productFile;
            }
        }

        return null;
    };

    componentDidMount() {
        let file = this.getFileById(this.props.params.fileId);

        if (file !== null) {
            let pageNumber = this.isNotVisited(file.id) ? 1 : this.props.params.visited[file.id].page;
            let image = window.imageStore.getProductFileImageById(file.id, pageNumber, this.props.params.online);

            if (image === null) {
                this.props.dispatchInitFilePreviewAction(this.props.tabId, file.id, this.props.params.online);
            }

            this.setState({
                activeFile: file,
                image: image,
                online: this.props.params.online,
                pageNumber: pageNumber,
                imageStore: this.props.imageStore,
                loading: image === null
            });
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.imageStore !== prevState.imageStore) {
            if (prevState.activeFile === null) {
                return null;
            }

            return {
                image: window.imageStore.getProductFileImageById(
                    prevState.activeFile.id,
                    prevState.pageNumber,
                    prevState.online
                ),
                imageStore: nextProps.imageStore,
                loading: false
            };
        }

        if (nextProps.productFileList !== prevState.productFileList) {
            if (prevState.activeFile === null) {
                return {
                    productFileList: nextProps.productFileList
                };
            }

            for (let productFile of nextProps.productFileList) {
                if (productFile.id === prevState.activeFile.id) {
                    return {
                        activeFile: productFile,
                        productFileList: nextProps.productFileList
                    };
                }
            }

            return {
                productFileList: nextProps.productFileList
            };
        }

        return null;
    }

    isVisited = (fileId) => {
        if (this.visitedParams === null || typeof this.visitedParams !== "object") {
            return false;
        }

        return this.visitedParams[fileId] !== undefined;
    };

    isNotVisited = (fileId) => {
        if (this.visitedParams === null || typeof this.visitedParams !== "object") {
            return true;
        }

        return this.visitedParams[fileId] === undefined;
    };

    buildVisited = () => {
        if (this.state.activeFile !== null && this.visitedParams !== null && typeof this.visitedParams === "object") {
            if (this.visitedParams[this.state.activeFile.id] === undefined) {
                this.visitedParams[this.state.activeFile.id] = {online: this.state.online, page: this.state.pageNumber};
            } else {
                this.visitedParams[this.state.activeFile.id] = {
                    ...this.visitedParams[this.state.activeFile.id],
                    page: this.state.pageNumber
                };
            }
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleMaximizeClick = () => {
        this.setState({
            maximized: !this.state.maximized
        });
    };

    handleProductFileClick = (event) => {
        let productFile = this.getFileById(Number(event.target.dataset.id));

        if (productFile !== null) {
            if (
                this.props.productFilesSource === settings.SOURCE_ASK &&
                productFile.isOnline() &&
                this.isNotVisited(productFile.id)
            ) {
                this.buildVisited();

                this.props.dispatchOpenProductFilesModalAction(this.props.tabId, {
                    fileId: productFile.id,
                    maximized: this.state.maximized,
                    visited: this.visitedParams
                });
                this.props.dispatchCloseModalAction();
            } else {
                let page = 1;
                let online = this.props.productFilesSource === settings.SOURCE_ONLINE && productFile.isOnline();
                let numberOfPages = 0;
                let image = null;

                if (this.isVisited(productFile.id)) {
                    page = this.visitedParams[productFile.id].page;
                    online = this.visitedParams[productFile.id].online;
                    numberOfPages = productFile.getNumberOfPages(online);
                    image = window.imageStore.getProductFileImageById(productFile.id, page, online);
                }

                if (image === null || numberOfPages === 0) {
                    this.props.dispatchInitFilePreviewAction(this.props.tabId, productFile.id, online);
                }

                this.buildVisited();

                this.setState({
                    activeFile: productFile,
                    image: image,
                    online: online,
                    pageNumber: page,
                    zoom: 100,
                    loading: image === null || numberOfPages === 0
                });
            }
        }
    };

    handleExportFileClick = () => {
        if (this.state.activeFile !== null) {
            this.props.dispatchGetFileAndExportAction(
                this.props.tabId,
                this.state.activeFile.id,
                this.state.activeFile.name
            );
        }
    };

    handleZoomOutClick = () => {
        if (this.state.zoom > 100) {
            this.setState({zoom: this.state.zoom - 20});
        }
    };

    handleZoomInClick = () => {
        if (this.state.zoom < 260) {
            this.setState({zoom: this.state.zoom + 20});
        }
    };

    handlePreviousClick = () => {
        if (this.state.activeFile !== null && this.state.pageNumber > 1) {
            let image = window.imageStore.getProductFileImageById(
                this.state.activeFile.id,
                this.state.pageNumber - 1,
                this.state.online
            );

            if (image === null) {
                this.props.dispatchGetFilePreviewAction(
                    this.props.tabId,
                    this.state.activeFile.id,
                    this.state.pageNumber - 1,
                    this.state.online
                );
            }

            this.setState({pageNumber: this.state.pageNumber - 1, image: image, loading: image === null});
        }
    };

    handleNextClick = () => {
        if (
            this.state.activeFile !== null &&
            this.state.pageNumber < this.state.activeFile.getNumberOfPages(this.state.online)
        ) {
            let image = window.imageStore.getProductFileImageById(
                this.state.activeFile.id,
                this.state.pageNumber + 1,
                this.state.online
            );

            if (image === null) {
                this.props.dispatchGetFilePreviewAction(
                    this.props.tabId,
                    this.state.activeFile.id,
                    this.state.pageNumber + 1,
                    this.state.online
                );
            }

            this.setState({pageNumber: this.state.pageNumber + 1, image: image, loading: image === null});
        }
    };

    handlePageClick = (event) => {
        let page = Number(event.currentTarget.dataset.page);

        if (
            this.state.activeFile !== null &&
            page > 0 &&
            page <= this.state.activeFile.getNumberOfPages(this.state.online)
        ) {
            let image = window.imageStore.getProductFileImageById(
                this.state.activeFile.id,
                this.state.pageNumber + 1,
                this.state.online
            );

            if (image === null) {
                this.props.dispatchGetFilePreviewAction(
                    this.props.tabId,
                    this.state.activeFile.id,
                    this.state.pageNumber + 1,
                    this.state.online
                );
            }

            this.setState({pageNumber: page, image: image, loading: image === null});
        }
    };

    getFileButtons = () => {
        let files = [];

        for (let file of this.props.productFileList) {
            if (this.state.activeFile === null || this.state.activeFile.id !== file.id) {
                files.push(
                    <button
                        key={file.id}
                        className="btn btn-info action-button"
                        data-id={file.id}
                        onClick={this.handleProductFileClick}
                    >
                        {translationHelper.getFileTypeTranslations(file.fileType)}
                    </button>
                );
            } else {
                files.push(
                    <button key={file.id} className="btn btn-info action-button active">
                        {translationHelper.getFileTypeTranslations(file.fileType)}
                    </button>
                );
            }
        }

        return files;
    };

    getZoomOutButton = () => {
        if (this.state.image !== null && this.state.zoom > 100) {
            return (
                <button className="btn btn-link action-button" onClick={this.handleZoomOutClick}>
                    <ReactSVG className="" src={imgZoomOut} alt="zoom" />
                </button>
            );
        }

        return (
            <button className="btn btn-link action-button disabled">
                <ReactSVG className="" src={imgZoomOut} alt="zoom" />
            </button>
        );
    };

    getZoomInButton = () => {
        if (this.state.image !== null && this.state.zoom < 260) {
            return (
                <button className="btn btn-link action-button" onClick={this.handleZoomInClick}>
                    <ReactSVG className="" src={imgZoomPlus} alt="zoom" />
                </button>
            );
        }

        return (
            <button className="btn btn-link action-button disabled">
                <ReactSVG className="" src={imgZoomPlus} alt="zoom" />
            </button>
        );
    };

    getExportFileButton = () => {
        if (this.props.loggedUser.canNotRead(resources.FUNCTION_EXPORT_PRODUCT_FILE_TO_PDF)) {
            return null;
        }

        return (
            <button className="btn btn-link action-button btn-export" onClick={this.handleExportFileClick}>
                <ReactSVG className="" src={imgDownload} alt="download" />
            </button>
        );
    };

    getPreviousButton = () => {
        if (this.state.activeFile === null) {
            return null;
        }

        if (this.state.image !== null && this.state.pageNumber > 1) {
            return <span className="glyphicon glyphicon-menu-left" onClick={this.handlePreviousClick}></span>;
        }

        return <span className="glyphicon glyphicon-menu-left disabled"></span>;
    };

    getNextButton = () => {
        if (this.state.activeFile === null) {
            return null;
        }

        if (
            this.state.image !== null &&
            this.state.pageNumber < this.state.activeFile.getNumberOfPages(this.state.online)
        ) {
            return <span className="glyphicon glyphicon-menu-right" onClick={this.handleNextClick}></span>;
        }

        return <span className="glyphicon glyphicon-menu-right disabled"></span>;
    };

    getMaximizeButton = () => {
        if (this.state.maximized) {
            return (
                <ReactSVG className="maximize" src={imgMaximize} alt="Maximize" onClick={this.handleMaximizeClick} />
            );
        }

        return (
            <ReactSVG
                className="maximizable"
                src={imgMaximizable}
                alt="Maximizable"
                onClick={this.handleMaximizeClick}
            />
        );
    };

    getPdfPreview = () => {
        if (this.state.loading) {
            return (
                <div className="col-xs-12 pdf-content">
                    <img className="pdf-loader" alt="new-order" src={imgLoader} />
                </div>
            );
        }

        if (this.state.image === null) {
            return (
                <div className="col-xs-12 pdf-content">
                    <img alt="no-img" src={noImg} />
                </div>
            );
        }

        return (
            <div
                className="col-xs-12 pdf-content slim-scroll"
                style={{height: "600px", marginTop: "10px", textAlign: "center"}}
            >
                <img
                    alt=""
                    src={"data:" + this.state.image.type + ";base64," + this.state.image.img}
                    style={{height: this.state.zoom + "%"}}
                />
            </div>
        );
    };

    getModalContent = () => {
        if (this.state.activeFile === null) {
            return "File does not exist";
        }

        return (
            <div>
                <div className="header">
                    {this.getFileButtons()}
                    <span className="file-name">{this.state.activeFile.name}</span>
                    <div className="btn-box">
                        {this.getZoomOutButton()}
                        {this.getZoomInButton()}
                        {this.getExportFileButton()}
                    </div>
                </div>
                {this.getPdfPreview()}
                {this.getPreviousButton()}
                {this.getNextButton()}
            </div>
        );
    };

    render() {
        return (
            <div className={"default-modal files-viewer-modal" + (this.state.maximized ? " maximized" : "")}>
                <header className="color-primary">
                    <ReactSVG className="pdf-icon" src={imgPdf} alt="pdf" />
                    <Translate value="mainTab.productFilesViewer" />
                    <ReactSVG className="img-close" src={imgClose} alt="close" onClick={this.handleCloseModalClick} />
                    {this.getMaximizeButton()}
                </header>
                <div className="modal-content">{this.getModalContent()}</div>
            </div>
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.formula[ownProps.tabId] === undefined) {
        return {
            loggedUser: store.login.loggedUser,
            productFileList: [],
            imageStore: store.navigation.imageStore,
            productFilesSource: store.settings.productFilesSource
        };
    }

    return {
        loggedUser: store.login.loggedUser,
        productFileList: store.formula[ownProps.tabId].productFileList,
        imageStore: store.navigation.imageStore,
        productFilesSource: store.settings.productFilesSource
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PRODUCT_FILE_PREVIEW_MODAL));
        },
        dispatchOpenProductFilesModalAction: (tabId, params) => {
            dispatch(navigationActions.openModalWithParams(tabId, componentTypes.PRODUCT_FILES_MODAL, params));
        },
        dispatchInitFilePreviewAction: (tabId, fileId, online) => {
            dispatch(mainTabActions.initFilePreview(tabId, fileId, online));
        },
        dispatchGetFilePreviewAction: (tabId, fileId, page, online) => {
            dispatch(mainTabActions.getFilePreview(tabId, fileId, page, online));
        },
        dispatchGetFileAndExportAction: (tabId, fileId, fileName) => {
            dispatch(mainTabActions.getFileAndExport(tabId, fileId, fileName));
        }
    };
};

export default ProductFilePreviewModal = connect(mapStoreToProps, mapDispatchToProps)(ProductFilePreviewModal);
